import { client }  from '../util/createRestApiClient';
import { loading } from "./index";

const base = "investigationAdvocate/";
export default () => ({
    getAdvocate: (id) => loading(client.request({
      method: 'GET',
      url: base + 'getAdvocate/' + id
    })),
    getAll: (filterName = "", columnSort = "", descending = true) => client.request({
      method: 'GET',
      url: base + 'getAll?filter=' + filterName + '&columnSort=' + columnSort + '&descending=' + descending
    }),
    getAdvocatesUsers: (filterName = "", columnSort = "", descending = true) => client.request({
      method: 'GET',
      url: base + 'GetAdvocatesUsers?filter=' + filterName + '&columnSort=' + columnSort + '&descending=' + descending
    }),
    getAllByInvestigation: (investigationId, filterName = "", columnSort = "", descending = true) => client.request({
      method: 'GET',
      url: base + 'getAllByInvestigation/' + investigationId + '?filter=' + filterName + '&columnSort=' + columnSort + '&descending=' + descending
    }),
    getAdvocates: (limit = 10, skip = 0, filterName = "", columnSort = "", descending = true) => loading(client.request({
      method: 'GET',
      url: base + 'getAdvocates?limit=' + limit + '&skip=' + skip + '&filter=' + filterName + '&columnSort=' + columnSort + '&descending=' + descending
    })),
    getAdvocatesByInvestigation: (investigationId, limit = 10, skip = 0, filterName = "", columnSort = "", descending = true) => loading(client.request({
      method: 'GET',
      url: base + 'getAdvocates/' + investigationId + '?limit=' + limit + '&skip=' + skip + '&filter=' + filterName + '&columnSort=' + columnSort + '&descending=' + descending
    })),
    addAdvocate: (params) => client.request({
      method: 'POST',
      url: base + 'addAdvocate',
      data: params
    }),
    updateAdvocate: (params) => client.request({
      method: 'PUT',
      url: base + 'UpdateAdvocate/' + params.id,
      data: params
    }),
    changeState: (params) => client.request({
      method: 'PUT',
      url: base + 'ChangeState/' + params.id + "?isOpen=" + params.isOpen,
    }),
    deleteAdvocate: (params) => client.request({
      method: 'DELETE',
      url: base + 'deleteAdvocate/' + params.id
    })
  }
);
